import { deApi } from '../../services/deService';

/* eslint-disable global-require */
const middleware = [deApi.middleware];

/* istanbul ignore next */
if (process.env.NODE_ENV === 'development') {
  const { createLogger } = require('redux-logger');
  const invariant = require('redux-immutable-state-invariant').default;

  middleware.push(invariant(), createLogger({ collapsed: true }));
}

export default middleware;
